import { SearchableWorkspace, Workspace } from "@radarly/models/workspace";
export interface Pagination {
  start: number;
  limit: number;
}
export interface WorkspaceRepository {
  getProjectWorkspaces(projectId: number): Promise<Workspace[]>;
  getCurrentWorkspace(): Workspace;
  searchWorkspaces(
    search: string,
    pagination: Pagination
  ): Promise<SearchableWorkspace[]>;
}

export const WorkspaceRepositoryUID = Symbol("Radarly/WorkspaceRepository");
